function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import ButtonRedirect from './components/ButtonRedirect';
import { BUTTON_TYPES, INPUT_SIZES } from '@zillow/constellation';
import { DTS_LOW_PRICE_TARGET_ID, DTS_LOW_PRICE_TARGET_LABEL, DTS_MIDDLE_PRICE_TARGET_ID, DTS_MIDDLE_PRICE_TARGET_LABEL, DTS_TOP_PRICE_TARGET_ID, DTS_TOP_PRICE_TARGET_LABEL } from './constants';
export default {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;

    var _useState = useState(null),
        _useState2 = _slicedToArray(_useState, 2),
        urlPath = _useState2[0],
        setUrlPath = _useState2[1];

    useEffect(function () {
      setUrlPath(window.location.href);
    }, []);
    var _attrs$defaultLabel = attrs.defaultLabel,
        defaultLabel = _attrs$defaultLabel === void 0 ? '' : _attrs$defaultLabel,
        _attrs$buttonType = attrs.buttonType,
        buttonType = _attrs$buttonType === void 0 ? BUTTON_TYPES.primary : _attrs$buttonType,
        _attrs$size = attrs.size,
        size = _attrs$size === void 0 ? INPUT_SIZES.sm : _attrs$size,
        _attrs$bottomPriceTar = attrs.bottomPriceTargetId,
        bottomPriceTargetId = _attrs$bottomPriceTar === void 0 ? DTS_LOW_PRICE_TARGET_ID : _attrs$bottomPriceTar,
        _attrs$bottomPriceTar2 = attrs.bottomPriceTargetLabel,
        bottomPriceTargetLabel = _attrs$bottomPriceTar2 === void 0 ? DTS_LOW_PRICE_TARGET_LABEL : _attrs$bottomPriceTar2,
        _attrs$middlePriceTar = attrs.middlePriceTargetId,
        middlePriceTargetId = _attrs$middlePriceTar === void 0 ? DTS_MIDDLE_PRICE_TARGET_ID : _attrs$middlePriceTar,
        _attrs$middlePriceTar2 = attrs.middlePriceTargetLabel,
        middlePriceTargetLabel = _attrs$middlePriceTar2 === void 0 ? DTS_MIDDLE_PRICE_TARGET_LABEL : _attrs$middlePriceTar2,
        _attrs$topPriceTarget = attrs.topPriceTargetId,
        topPriceTargetId = _attrs$topPriceTarget === void 0 ? DTS_TOP_PRICE_TARGET_ID : _attrs$topPriceTarget,
        _attrs$topPriceTarget2 = attrs.topPriceTargetLabel,
        topPriceTargetLabel = _attrs$topPriceTarget2 === void 0 ? DTS_TOP_PRICE_TARGET_LABEL : _attrs$topPriceTarget2;
    return /*#__PURE__*/React.createElement(ButtonRedirect, {
      urlPath: urlPath,
      defaultLabel: defaultLabel,
      buttonType: buttonType,
      size: size,
      bottomPriceTargetId: bottomPriceTargetId,
      bottomPriceTargetLabel: bottomPriceTargetLabel,
      middlePriceTargetId: middlePriceTargetId,
      middlePriceTargetLabel: middlePriceTargetLabel,
      topPriceTargetId: topPriceTargetId,
      topPriceTargetLabel: topPriceTargetLabel
    });
  },
  metadata: {
    schema: 'https://schemas.wp.org/trunk/block.json',
    version: '1.0',
    name: 'seller-tech/custom-dts-cta',
    title: 'Showcase DTS Button',
    description: 'Button that redirects to Showcase DTS contact page',
    icon: 'button',
    keywords: ['showcase', 'dts', 'cta'],
    category: 'more',
    attributes: {
      defaultLabel: {
        type: 'string',
        label: 'Default label',
        default: '',
        control: 'text'
      },
      bottomPriceTargetId: {
        type: 'string',
        label: 'Bottom Price Target ID',
        default: DTS_LOW_PRICE_TARGET_ID,
        control: 'text'
      },
      bottomPriceTargetLabel: {
        type: 'string',
        label: 'Bottom Price Target Label',
        default: DTS_LOW_PRICE_TARGET_LABEL,
        control: 'text'
      },
      middlePriceTargetId: {
        type: 'string',
        label: 'Middle Price Target ID',
        default: DTS_MIDDLE_PRICE_TARGET_ID,
        control: 'text'
      },
      middlePriceTargetLabel: {
        type: 'string',
        label: 'Middle Price Target Label',
        default: DTS_MIDDLE_PRICE_TARGET_LABEL,
        control: 'text'
      },
      topPriceTargetId: {
        type: 'string',
        label: 'Top Price Target ID',
        default: DTS_TOP_PRICE_TARGET_ID,
        control: 'text'
      },
      topPriceTargetLabel: {
        type: 'string',
        label: 'Top Price Target Label',
        default: DTS_TOP_PRICE_TARGET_LABEL,
        control: 'text'
      },
      size: {
        type: 'string',
        default: INPUT_SIZES.sm,
        label: 'Button Size',
        control: 'select',
        choices: [{
          label: 'Small',
          value: INPUT_SIZES.sm
        }, {
          label: 'Medium',
          value: INPUT_SIZES.md
        }, {
          label: 'Large',
          value: INPUT_SIZES.lg
        }]
      },
      buttonType: {
        type: 'string',
        default: BUTTON_TYPES.primary,
        label: 'Button Type',
        control: 'select',
        choices: [{
          label: 'Primary',
          value: BUTTON_TYPES.primary
        }, {
          label: 'Secondary',
          value: BUTTON_TYPES.secondary
        }, {
          label: 'Caution',
          value: BUTTON_TYPES.caution
        }, {
          label: 'Tertiary',
          value: BUTTON_TYPES.tertiary
        }]
      }
    }
  }
};
//# sourceMappingURL=index.js.map